import { render } from "./TelaNotFound.vue?vue&type=template&id=5e38200c&scoped=true"
const script = {}

import "./TelaNotFound.vue?vue&type=style&index=0&id=5e38200c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e38200c"]])

export default __exports__